export const unaccentAndLower = (str) => {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};
//# sourceMappingURL=unaccentAndLower.js.map